// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import installPlugin from '@/plugin'
import 'view-design/dist/styles/iview.css'
import './index.less'
import '@/assets/icons/iconfont.css'
import '@/plugin/jquery-vendor.js'
import 'ztree' // 树
import JsonViewer from 'vue-json-viewer' // Json渲染

import GeminiScrollbar from 'vue-gemini-scrollbar' // 自定义滚动条

import { library } from '@fortawesome/fontawesome-svg-core' // FontAwesome图标
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' // FontAwesome图标
import { fas } from '@fortawesome/free-solid-svg-icons' // FontAwesome图标
import '@/assets/iconfont/iconfont.css' // 阿里巴巴图标

import VueNativeSock from 'vue-native-websocket' // WS 插件

import VueClipboard from 'vue-clipboard2' // 剪贴板插件

import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from './store/module/mutation-types'

import Viewer from 'v-viewer' // 图片预览插件
import 'viewerjs/dist/viewer.css' // 图片预览插件Css

// 实际打包时应该不引入mock
/* eslint-disable */
if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.use(iView, { i18n: (key, value) => i18n.t(key, value) })
Vue.use(GeminiScrollbar)

Vue.use(JsonViewer)

const mutations = {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
}

Vue.use(Viewer, {
  defaultOptions: {
    title: false,
    navbar: false,
    toolbar: false
  }
})

Vue.use(VueNativeSock, config.wsMessageUrl + '/ws_message/public/', {format: 'json', store: store, mutations: mutations})

Vue.use(VueClipboard)


import Clipboard from 'v-clipboard'
Vue.use(Clipboard)


library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

require("expose-loader?$!jquery")

/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * 注册指令
 */
importDirective(Vue)

/* eslint-disable no-new */
const theme = localStorage.getItem('theme') || 'themeOne'
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App),
  mounted() {
    document.querySelector('body').className = theme
  }
})

